module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer2_offgrid_generator_lt 1.64e24cb6.svg";